<template>
  <div
    v-if="pageLoading"
    class="m-3"
  >
    <placeholder-content :is-load="true" />
  </div>
  <div
    v-else-if="!hasPermission"
    class="m-3"
  >
    <access-denied/>
  </div>
  <div
    v-else
  >
    <div class="d-flex border-bottom mb-3 justify-content-between align-items-end">
      <div class="overflow-auto hide-scrollbar flex-grow-1">
        <ul class="nav nav-custom flex-nowrap">
          <li class="nav-item" v-for="viewpoint in viewpoints">
            <a class="nav-link text-nowrap" :class="params.viewpoint == viewpoint.value ? 'active' : ''"
              @click="setViewpoint(viewpoint.value)" style="cursor: pointer;">
              {{ $t(viewpoint.text) }}
              <span class="badge rounded-pill ms-1" :class="[viewpoint.bgc]">
                {{ viewpoint.count }}
              </span>
            </a>
          </li>
        </ul>
      </div>
      <column-toggle
        :headers="allHeaders"
        storage-key="inventory-production-batches.columns"
        v-model="visibleColumns"
      />
    </div>
    <div class="d-flex justify-content-start mx-3 flex-column flex-sm-row">
      <div class="btn-group btn-group-sm me-sm-2 mb-3">
        <button
          type="button"
          class="btn btn-sm btn-primary"
          @click="() => {
            offcanvasFroms.open = true;
            offcanvasFroms.viewOnly = false;
            offcanvasFroms.type = 'CREATE';
          }"
        >
          <i class="fa-solid fa-circle-plus me-2" />
          {{ $t('Create') }}
        </button>
      </div>

      <div class="custom-input-group input-group input-group-sm me-sm-2 mb-3 w-auto">
        <input
          type="search"
          class="form-control"
          :placeholder="$t('search')+'...'"
          aria-label="Search"
          aria-describedby="search-addon"
          v-model.trim="params.search"
          @keyup.enter="fetchData"
        >
        <button
          class="input-group-text"
          type="button"
          @click="fetchData"
        >
          <i class="fas fa-search" />
        </button>
      </div>
      <per-page
        @per-page="setPerPage"
      />
    </div>
    <vue3-easy-data-table
      v-model:server-options="datatable.serverOptions"
      ref="dataTable"
      :headers="visibleHeaders"
      :items="datatable.items"
      :loading="datatable.loading"
      :server-items-length="datatable.total"
      :theme-color="'#515151'"
      :hide-footer="false"
      :hide-rows-per-page="true"
      :empty-message="$t('No Available Data')"
      :table-min-height="null"
      buttons-pagination
      :body-item-class-name="bodyItemClassNameFunction"
      table-class-name='customize-table'
    >
      <template #header-created_by="header">
        <span class="w-100 text-end">
          {{ header.text }}
        </span>
      </template>
      <template #item-status="item">
        <span
          :class="['badge', viewpoints.find((viewpoint) => viewpoint.value == item.status).bgc]"
          style="text-transform: capitalize"
        >
          {{ item.status }}
        </span>
      </template>
      <template #item-batch_multiplier="item">
        {{ formatNumberTwoDigit(item.batch_multiplier) + $t('_BatchSize.x') }}
      </template>
      <template #item-created_at="item">
        {{ formatDateTime(item.created_at) }}
      </template>
      <template #item-action="item">
        <div class="icon-link custom-actions">
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-title="Custom popover"
              data-bs-content="This popover is themed via CSS variables."
              class="btn btn-outline-primary btn-sm btn-icon"
              @click="() => {
                viewForm.open = true;
                viewForm.id = item.id;
              }"
            >
              <i class="fa-solid far fa-eye" />
            </button>
            <template #content>
              <div>{{ $t('View') }}</div>
            </template>
          </popper>
          <!-- <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            v-if="item.status === 'draft'"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-title="Custom popover"
              data-bs-content="This popover is themed via CSS variables."
              class="btn btn-outline-primary btn-sm btn-icon"
              @click="() => {
                offcanvasFroms.open = true;
                offcanvasFroms.id = item.id;
                offcanvasFroms.type = 'EDIT';
              }"
            >
              <i class="fa-solid fa-square-pen" />
            </button>
            <template #content>
              <div>{{ $t('Edit') }}</div>
            </template>
          </popper> -->
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            v-if="item.status === 'draft'"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              class="btn btn-outline-primary btn-sm btn-icon"
              @click="handleDelete(item.id)"
            >
              <i class="fa-solid fa-trash-can" />
            </button>
            <template #content>
              <div>{{ $t('Delete') }}</div>
            </template>
          </popper>
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            v-if="['pending','progressing'].includes(item.status)"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              class="btn btn-outline-primary btn-sm btn-icon"
              @click="handleCancel(item.id, item.status)"
            >
              <i class="fa-solid fa-ban" />
            </button>
            <template #content>
              <div>{{ $t('Cancel') }}</div>
            </template>
          </popper>
        </div>
      </template>
      <template #loading>
        <i class="fa-solid fa-spinner fa-spin fa-2xl" />
      </template>
    </vue3-easy-data-table>
    <offcanvas-form
      v-if="offcanvasFroms.open"
      :type="offcanvasFroms.type"
      :id="offcanvasFroms.id"
    />
    <offcanvas-view-form
      v-if="viewForm.open"
      :id="viewForm.id"
    />
  </div>
</template>
<script lang="js">
import Vue3EasyDataTable from 'vue3-easy-data-table';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import PerPage from '@/plugins/PerPage.vue';
import FieldsDef from "./assets/template/datatable/FieldsDef";
import OffcanvasForm from './OffcanvasForm.vue';
import ColumnToggle from '@/components/shared/ColumnToggle.vue';
import { loadVisibleColumns } from '@/utils/columnToggle';
import { InventoryProductionBatches } from '@/services/endpoint/inventory-production-batches.service';
import moment from "moment";
import numeral from 'numeral';
import Popper from "vue3-popper";
import OffcanvasViewForm from './OffcanvasViewForm.vue';

export default {
  data() {
    return {
      params: {
        limit: 10,
        page: 1,
        search: '',
        viewpoint: 'all'
      },
      viewForm: {
        open: false,
        id: 0,
      },
      pageLoading: false,
      hasPermission: false,
      datatable: {
        loading: false,
        headers: FieldsDef,
        items: [],
        total: 0,
        serverOptions: {
          page: 1,
          rowsPerPage: 10
        }
      },
      offcanvasFroms: {
        open: false,
        type: 'CREATE',
        customerId: 0,
        viewOnly: false
      },
      viewpoints: [
        {
          value: 'all',
          text: 'All',
          count: 0,
          bgc: 'bg-primary text-white'
        },
        {
          value: 'draft',
          text: 'Draft',
          count: 0,
          bgc: 'bg-secondary text-white'
        },
        {
          value: 'pending',
          text: 'Pending',
          count: 0,
          bgc: 'bg-warning text-dark'
        },
        {
          value: 'progressing',
          text: 'Progressing',
          count: 0,
          bgc: 'bg-info text-dark'
        },
        {
          value: 'completed',
          text: 'Completed',
          count: 0,
          bgc: 'bg-success text-white'
        },
        {
          value: 'cancelled',
          text: 'Cancelled',
          count: 0,
          bgc: 'bg-danger text-white'
        }
      ],
      visibleColumns: loadVisibleColumns('inventory-production-batches.columns', FieldsDef(t => t))
    }
  },
  components: {
    PlaceholderContent,
    AccessDenied,
    PerPage,
    Vue3EasyDataTable,
    OffcanvasForm,
    ColumnToggle,
    Popper,
    OffcanvasViewForm
  },
  computed: {
    allHeaders() {
      return this.datatable.headers(this.$t);
    },
    visibleHeaders() {
      return this.allHeaders.filter(h => !h.togglable || this.visibleColumns.includes(h.value));
    }
  },
  async mounted() {
    this.pageLoading = true;
    await this.fetchData();
    this.pageLoading = false;
  },
  methods: {
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    bodyItemClassNameFunction(column, rowNumber) {
      let className = 'align-top py-1 px-2';
      const columnCenter = [];
      const columnEnd = ['created_by'];
      if (columnCenter.includes(column)) {
        className += ' text-center';
      }
      if (columnEnd.includes(column)) {
        className += ' text-end';
      }
      return className;
    },
    showInputItems(items) {
      return items.map(item => {
        return item.name + ' (' + this.formatNumber(item.quantity) + item.unit_symbol + ')';
      }).join(', ');
    },
    async setViewpoint(tab) {
      if (this.params.viewpoint == tab) return;
      this.params.viewpoint = tab;
      await this.fetchData();
    },
    async fetchData() {
      this.datatable.loading = true;
      var queryString = '?' + $.param(this.params);
      await InventoryProductionBatches.list(queryString).then(res => {
        this.datatable.items = res.data.data;
        this.datatable.total = res.data.meta.total;
        this.viewpoints.forEach(viewpoint => {
          viewpoint.count = res.data.viewpoint_cnt[viewpoint.value];
        });
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
        }
      });

      this.datatable.loading = false;
      return;
    },
    setPerPage(perPage) {
      this.params.limit = perPage;
      this.$refs.dataTable.updateRowsPerPageActiveOption(perPage);
      this.fetchData();
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    async handleDelete(id) {
      try {
        let self = this;
        let title = this.$t("Delete Draft Plan") + '?';
        let html = this.$t('This draft will be permanently deleted. You cannot undo this action!');
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Yes, delete it!");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return InventoryProductionBatches.delete(id)
              .then((response) => {
                self.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Success!'));
                // $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else if (error?.response?.data?.code === "VALIDATION") {
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    async handleCancel(id, status) {
      try {
        let self = this;
        let title = this.$t("Cancel Production") + '?';
        let html = this.$t(`No stock has been deducted yet. This is a safe cancellation.`) + '<br>' + this.$t(`Please provide a reason for our records`) + ':';
        let confirmButtonText = this.$t("Yes, Cancel Batch");
        let cancelButtonText = this.$t("No, Keep it");
        if (status === 'progressing') {
          title = this.$t("Abort Production") + '?';
          html = '⚠️ <b>' + this.$t(`Critical Warning`) + ': </b><br>';
          html+= this.$t('Any ingredients already recorded (used) will be marked as') + ' <b>' + this.$t('WASTE') + '</b> ' + this.$t('and will NOT be returned to inventory.') + '<br><br>' + this.$t('Please provide a reason for aborting this job') + ':';
          confirmButtonText = this.$t("Yes, Abort & Mark Waste");
          cancelButtonText = this.$t("No, Continue Production");
        }
        this.$swal({
          icon: "warning",
          input: 'textarea',
          inputLabel: self.$t('Reason for cancellation (Required)')+ ':',
          inputPlaceholder: self.$t('Type your reason here (e.g., Wrong recipe, Machine failure)')+ '...',
          inputAttributes: {
            'rows': 3
          },
          target: document.getElementById('offcanvaInfo'),
          iconColor: "#FF7043",
          title: title,
          html: html,
          showCancelButton: true,
          cancelButtonText: cancelButtonText,
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          inputValidator: (value) => {
            if (!value || value.trim() === '') {
              return self.$t('You must provide a reason to proceed') + '!';
            }
          },
          preConfirm: async function (value) {
            let params = {
              reason: value
            };
            return InventoryProductionBatches.cancel(id, params)
              .then((response) => {
                self.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Cancel Success!'));
                // $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else if (error?.response?.data?.code === "VALIDATION") {
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
  },
  watch: {
    "datatable.serverOptions" (nval, oval) {
      delete this.params.sort;
      this.params.page = nval.page;
      this.params.limit = nval.rowsPerPage;
      if (nval.sortBy && nval.sortType) this.params.sort = nval.sortBy + "|" + nval.sortType;
      this.fetchData();
    }
  }
}
</script>
